import { Card, Badge, Spinner } from "react-bootstrap";
import { Bot } from "lucide-react";

export const AIPanel = ({ loading, speaking, text, typing }) => (
  <Card className="h-100">
    <Card.Body>
      {/* {speaking || loading ? (
        <div className="ratio ratio-16x9 p-3 border rounded overflow-auto">
          {loading ? (
            <div className="d-flex flex-column align-items-center justify-content-center h-100">
                <Spinner animation="border" size="sm" />
                <span className="mt-2">AI is thinking...</span>
            </div>
          ) : (
            <p className="mb-0 px-2 py-2">{text || "AI response will appear here..."}</p>
          )}
        </div>
      ) : (
        <div className="ratio ratio-16x9 bg-dark d-flex justify-content-center align-items-center">
          <img src="/assets/images/support/man.jpeg" alt="AI Avatar" />
        </div>
      )} */}
      <div className="ratio ratio-16x9 bg-dark d-flex justify-content-center align-items-center">
        <img src="/assets/images/support/man.jpeg" alt="AI Avatar" />
      </div>

      <div className="d-flex justify-content-between mt-3">
        <span><Bot size={18} /> AI Opponent</span>
        {typing && (
          <Badge bg="secondary">AI is thinking...</Badge>
        )}
        {speaking && <Badge bg="primary">Speaking</Badge>}
      </div>
    </Card.Body>
  </Card>
);
